module.exports = __webpack_public_path__ + "static/profile-pic-75e84cee9d5a197de05a3d6a3d81da08.jpg";